<template>
  <div
    class="qrcode-container"
    @scroll.stop.prevent
    @mousemove.stop="(e)=>{e.preventDefault()}"
    @touchmove.stop="(e)=>{e.preventDefault()}"
  >
    <div class="modal">
      <div class="modal-card">
        <div class="header flex">
          <button
            type="button"
            data-testid="back-button"
            class="icon-button layout-header__icon"
            @click="hideQrcode"
          ><svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.707 4.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z"
                fill="#ffffff"
              ></path>
            </svg></button>
          <h1
            class="typography typography--title  typography--primary  layout-header__typography"
            data-testid="dynamic-auth-modal-heading"
            copykey="dyn_login.qr_code.title"
          >Connect OKX Wallet</h1>
          <button
            type="button"
            data-testid="back-button"
            class="icon-button layout-header__icon"
            @click="hideQrcode"
          ></button>
        </div>
        <div>
          <img :src="url">
        </div>
        <div class="qrcode-container__top">
          <div class="button-container"><button class="button button--expanded button--padding-small button--primary qr-code-button">
              <div
                class="button__start-slot"
                @click="copyHandler"
              ><span
                  class="typography typography--button-primary  typography--primary  "
                  copykey="dyn_qr_code.copy_button"
                >Copy QR URI</span><svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class=" icon--color-text-tertiary icon--size-mini"
                >
                  <path
                    d="M11.833 4.667H9.167V6h2.666c1.1 0 2 .9 2 2s-.9 2-2 2H9.167v1.333h2.666a3.335 3.335 0 0 0 0-6.666Zm-4 5.333H5.167c-1.1 0-2-.9-2-2s.9-2 2-2h2.666V4.667H5.167a3.335 3.335 0 0 0 0 6.666h2.666V10Zm-2-2.667h5.334v1.334H5.833V7.333Z"
                    fill="#ffffff"
                  ></path>
                </svg></div>

            </button></div>
        </div>
        <p
          class="typography typography--body-normal typography--regular typography--secondary  qrcode-container__content"
          copykey="dyn_qr_code.scan_title"
        >Scan this QR code from your mobile wallet or phone's camera to connect.</p>
      </div>
    </div>
  </div>
</template>
<script>
import { emitter, Events } from '@/common/mitt'

export default {
  name: 'QrCode',
  props: {
    url: {
      type: String,
      default: ""
    }
  },
  mounted () {
    document.body.addEventListener('touchmove', this.p, { passive: false })
    document.body.addEventListener('wheel', this.p, { passive: false })
  },
  beforeUnmount () {
    document.body.removeEventListener('wheel', this.p)
    document.body.removeEventListener('touchmove', this.p)
  },
  methods: {
    p (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    copyHandler () {
      navigator.clipboard.writeText(this.url);
      // alert("copy success!");
      emitter.emit(Events.EventMin, "copy success!");
    },
    hideQrcode () {
      this.$emit('hideQrCode');
    },
  },
}
</script>
<style lang="scss" scoped>
.qrcode-container {
  background-color: rgba($color: #000000, $alpha: 0.3);
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  pointer-events: auto;

  .modal-card {
    background: #100c18;
    border-radius: 10px;
    box-shadow: 0 1.5rem 2rem -1.5rem rgba(0, 0, 0, 0.24);
    overflow: hidden;
    width: 100%;
    transition: opacity 100ms linear;
    opacity: 1;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 30px;
  }

  .typography--title {
    text-align: center;
    flex: 1;
    color: white;
    padding-right:30px;
  }

  .typography--body-normal {
    color: white;
  }

  .button--primary {
    background: #f39700;
    border: #f39700 1px solid;
    padding: 20px;
    padding-top:15px;
    padding-bottom:15px;
  }

  .icon-button {
    align-items: center;
    border-radius: 100%;
    color: var(--dynamic-text-tertiary);
    display: flex;
    justify-content: center;
  }

  [type='button'],
  [type='reset'],
  [type='submit'],
  button {
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;
    background-color: transparent;
    background-image: none;
    cursor: pointer;
    border: none;
  }

  .layout-header__icon svg {
    height: 1.5rem;
    width: 1.5rem;
  }

  .modal {
    left: 50%;
    margin: auto;
    position: fixed;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 500px;
  }
}
.qrcode-container__top .button-container {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  margin-top: 20px;
  width: 100%;
  justify-content: center;
}

.typography--button-primary {
  font-size: 20px;
  font-weight: 700;
}

.typography-button__content {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.typography--primary {
  color: #f2f2f3;
  font-size: 18px;
  padding: 5px;
}
</style>